module.exports = __webpack_public_path__ + "img/parceiro4.cb9b459b.png";